<template lang="pug">
mixin actions()
  .ui.icon.circular.tiny.basic.button.action(
    v-if='$permission.has(action(key_action).permissions)'
    :class='[{icon:action(key_action).icon}, action(key_action).classes]',
    :data-tooltip='action(key_action).tooltip',
    data-position='top center', data-inverted='',
    @click='actionHandler(record, key_action, "left")',
    @contextmenu.prevent='actionHandler(record, key_action, "right")',
  )&attributes(attributes)
    template(v-if='action(key_action).corner && action(key_action).icon')
      i.icons
        i.icon(:class='action(key_action).icon')
        i.icon.corner(:class='action(key_action).corner')
    template(v-else)
      i.icon(v-if='action(key_action).icon', :class='action(key_action).icon')
    span(v-if='action(key_action).text') {{action(key_action).text}}

mixin pagination
  el-pagination(
    v-if='total_records > pagesize',
    small,
    :current-page.sync='inner_page_number',
    :page-size='inner_pagesize',
    :page-sizes='[15, 30, 50, 75]',
    :total='total_records',
    layout='total, prev, pager, next, sizes',
    @size-change='handle_size_change')

.auto-table(:class='printing')
  template(v-if='paginations === "top" || paginations === "both"')
    +pagination

  table.ui.very.basic.table(v-if='data && data.length', :class='{sortable, unstackable, compact, striped}')
    thead
      th.collapsing.no-print(v-if='leftActions')
      th(v-for='key in getLayout(layout).layout',
        :class='[prop(key).$classes(), sortedClasses(key), {sortable:prop(key).sortable}]',
        @click='header_click(key)')
        | {{prop(key).label}}
      th.collapsing.no-print(v-if='actions || detailView')

    tbody
      tr(v-for='(record, index) in page_data', :class='rowClasses(record)')
        td.collapsing.no-print(v-if='leftActions && !$media.isMobile')
          +actions()(v-for='key_action in left_action_keys(record)')

        td(v-for='key in getLayout(layout).layout', :class='prop(key).$classes(record)')
          span(@click='event => onclick(key, record, event)')
            template(v-if='getLayout(layout).form && prop(key).$type(record) === "select"')
              el-select(:value='record[prop(key).model]', @input='value => record[prop(key).model] = value',size='small')
                el-option(v-for='item in prop(key).$select(record)', :key='item.key', :label='item.label', :value='item.key')

            template(v-else-if='getLayout(layout).form && prop(key).$type(record) === "input"')
              el-input(:value='record[prop(key).model]', @input='value => record[prop(key).model] = value',size='small')

            template(v-else-if='prop(key).$type(record) === "phone"')
              a(:href='"tel:"+prop(key).$value(record)', :class='prop(key).$innerClasses(record)', style='white-space: nowrap;')
                i.ui.icon.phone
                | {{prop(key).$value(record)}}

            template(v-else)
              template(v-if='prop(key).maxlength')
                span(:class='prop(key).$innerClasses(record)',
                  data-inverted='', :data-tooltip='get_tooltip(key, record)',
                  :data-position='prop(key).tooltip')
                  | {{$formatters.limited(prop(key).$value(record), prop(key).maxlength)}}
              template(v-else)
                span(:class='prop(key).$innerClasses(record)') {{prop(key).$value(record)}}

        td.right.aligned.collapsing.no-print(v-if='(actions || detailView) && !$media.isMobile')
          template(v-if='actions')
            +actions()(v-for='key_action in right_action_keys(record)')

          template(v-if='detailView')
            el-popover(:ref='"popover" + index', :key='index', placement='top-end', width='600', trigger='hover')
              auto-detail(:defines='defines', :key='index', :data='record')
              .ui.icon.circular.tiny.basic.button.action(slot='reference')
                i.icon.expand

    tfoot(v-if='summary && data && data.length'): tr.summary
      th.collapsing.no-print(v-if='leftActions && !$media.isMobile')
      th(v-for='key in getLayout(layout).layout', :class='[prop(key).$classes(), sortedClasses(key)]') {{get_summary(key)}}
      th.collapsing.no-print(v-if='(actions || detailView) && !$media.isMobile')
  .no-record(v-if='!data || !data.length') 无记录

  template(v-if='paginations === "bottom" || paginations === "both"')
    +pagination
</template>

<script>
import AutoDetail from './AutoDetail.vue'
import MixAuto from './mixin'

export default {
  name: 'auto-table',
  components: { AutoDetail },
  mixins: [MixAuto],
  props: {
    data: Array,
    actions: null,
    leftActions: null,
    filters: Array,
    unstackable: { type: Boolean, default: false },
    sortable: { type: Boolean, default: false },
    paginations: { type: String, default: 'bottom' },
    pageNumber: { type: Number, default: 1 },
    pagesize: { type: Number, default: 15 },
    detailView: { type: Boolean, default: false },
    layout: { type: String, default: 'default' },
    rowClasses: { type: Function, default: () => '' },
    compact: { type: Boolean, default: true },
    striped: { type: Boolean, default: false },
    pageResetOnChange: { type: Boolean, default: false },
    summary: { type: Boolean, default: false },
  },
  data() {
    return {
      inner_page_number: 1,
      inner_pagesize: 15,
      printing: false,
      sortedStates: [],
    }
  },
  created() {
    // Hack to bypass actions
    // See usage in <File>: ./AutoEditTable.vue:36
    this.$beforeEmit = () => null
    const $emit = this.$emit
    this.$emit = (...args) => {
      /* eslint-disable prefer-spread */
      this.$beforeEmit.apply(this, args)
      $emit.apply(this, args)
    }
  },
  mounted() {
    this.inner_page_number = this.pageNumber || 1
    this.inner_pagesize = this.pagesize || 15
  },
  watch: {
    data() {
      if (this.pageResetOnChange)
        this.inner_page_number = 1
      else if (this.inner_page_number > this.total_pages)
        this.inner_page_number = 1
    },
    pageNumber() {
      this.inner_page_number = this.pageNumber || 1
    },
    inner_page_number(to, from) {
      if (to !== from)
        this.$emit('update:pageNumber', this.inner_page_number)
    },
  },
  computed: {
    filtered_data() {
      let data = this.data || []
      // filter
      if (this.filters && this.filters.length) {
        for (const filter_name of this.filters) {
          const filter = this.getFilter(filter_name)
          data = data.filter(filter) || []
        }
      }
      // sort
      if (this.sortable && this.sortedStates) {
        data = data.slice(0)
        let i = this.sortedStates.length
        while (i--) {
          const [field, state] = this.sortedStates[i]
          const prop = this.prop(field)
          if (state !== 0) {
            data.sort((a, b) => {
              if (prop && prop.sorter)
                return prop.sorter(a, b) * state

              const va = a[field] || ''
              const vb = b[field] || ''
              if (typeof va === 'string')
                return va.localeCompare(vb) * state
              if (typeof va === 'number')
                return (va - vb) * state
              /* eslint-disable no-nested-ternary */
              return va > vb ? 1 : (va < vb ? -1 : 0)
              /* eslint-enable no-nested-ternary */
            })
          }
        }
      }
      return data
    },
    total_records() {
      if (this.filtered_data)
        return this.filtered_data.length
      return 0
    },
    total_pages() {
      if (!this.inner_pagesize)
        return 0
      return Math.ceil(this.filtered_data.length / this.inner_pagesize)
    },
    page_data() {
      if (!this.inner_pagesize)
        return this.filtered_data
      const from = (this.inner_page_number - 1) * this.inner_pagesize
      const to = Math.min(this.filtered_data.length, (this.inner_page_number) * this.inner_pagesize)
      return this.filtered_data.slice(from, to)
    },
  },
  methods: {
    print_table() {
      this.printing = true
      window.print()
      this.printing = false
    },
    parse_action(actions_key, record) {
      let actions = []
      if (!this[actions_key])
        return actions

      if (typeof this[actions_key] === 'function')
        actions = this[actions_key].call(this, record)
      else
        actions = this[actions_key]

      if (!Array.isArray(actions))
        actions = actions.split(' ').filter(i => i) || []
      return actions
    },
    sortedClasses(prop_key) {
      if (this.sortable && this.sortedStates) {
        const propState = this.sortedStates.filter(([key, _]) => key === prop_key)[0]
        if (propState && propState.length >= 2) {
          const [, state] = propState
          if (state < 0)
            return 'sorted descending'
          else if (state > 0)
            return 'sorted ascending'
        }
      }
      return ''
    },
    right_action_keys(record) {
      return this.parse_action('actions', record)
    },
    left_action_keys(record) {
      return this.parse_action('leftActions', record)
    },
    overlength(key, record) {
      const prop = this.prop(key)
      const value = prop.$value(record)
      return value && value.length > prop.maxlength
    },
    get_tooltip(key, record) {
      const prop = this.prop(key)
      if (!prop.tooltip)
        return
      const value = prop.$value(record)
      const overlength = value && value.length > prop.maxlength
      if (overlength)
        return value
    },
    get_summary(key) {
      const prop = this.prop(key)
      if (prop.summary)
        return prop.summary.call(this, this.filtered_data)
    },
    header_click(key) {
      const prop = this.prop(key)
      if (this.sortable && prop.sortable) {
        const previous = this.sortedStates.filter(([k, _]) => k === key)[0]
        if (previous && previous[1] === 1)
          this.$set(previous, 1, -1)
        else if (previous && previous[1] === -1)
          this.sortedStates = []
        else
          this.sortedStates = [[key, 1]]
      }
    },
    onclick(key, record, event) {
      const prop = this.prop(key)
      if (prop.onclick)
        return prop.onclick.call(this, record, event)
    },
    handle_size_change(size) {
      this.inner_pagesize = size
    },
  },
}
</script>



// WEBPACK FOOTER //
// AutoTable.vue?7ac98c00